import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import DecoMethodCategoryAddEdit from "./DecoMethodCategoryAddEdit";
import DecoMethodCategoryTable from "./DecoMethodCategoryTable";

function DecoMethodCategoryContainer() {
  const { path } = useRouteMatch();
  return (
    <>
      <Switch>
        <Route exact path={`${path}/edit/:id`}>
          <DecoMethodCategoryAddEdit />
        </Route>
        <Route exact path={`${path}/add`}>
          <DecoMethodCategoryAddEdit />
        </Route>
        <Route path={`${path}`}>
          <DecoMethodCategoryTable />
        </Route>
      </Switch>
    </>
  );
}

export default DecoMethodCategoryContainer;
